export const OVERLAY_FAMILIES = [
  'caries',
  'inlay',
  'onlay',
  'erosion',
  'crown',
  'veneer',
  'bridge',
  'sealants',
  'missing',
  'implant',
  'layerVisibility',
  'furcation',
  'filling',
  'apicoectomy',
  'periapical',
  'rootCanal',
  'pulpotomy',
  'pulpectomy',
  'periradicular',
  'impacted',
  'drifted',
  'supernumerary',
  'sinusTract',
  'retainedPrimary',
  'recession',
  'attrition',
  'abrasion',
  'crack',
  'fracture',
  'prostheticStack',
] as const

export type OverlayFamily = (typeof OVERLAY_FAMILIES)[number]

export type OverlayFamilySignatures = Record<OverlayFamily, string>

/** Families whose stored signature differs. A first apply runs every family. */
export const familiesToApply = (
  previous: OverlayFamilySignatures | null,
  next: OverlayFamilySignatures,
): Set<OverlayFamily> => {
  if (!previous) {
    return new Set(OVERLAY_FAMILIES)
  }
  const changed = new Set<OverlayFamily>()
  OVERLAY_FAMILIES.forEach((family) => {
    if (previous[family] !== next[family]) {
      changed.add(family)
    }
  })
  return changed
}
